import React from 'react';
import { SubTitle, Description, Image } from '../../components/layouts';
import { buildImageURL, getTrack } from '../../helpers';
import LazyLoad from 'react-lazyload';
import './style.scss';

const CAMERA_LENS_2 = buildImageURL('/camera-lens-2.jpg');
const CAMERA_LENS_M_2 = buildImageURL('/camera-lens-m-2.jpg');

const track = getTrack({ block: 6 });

export function CameraLens2({mobile = false}) {
  return (
    <div className="page-section section-camera-lens-2 inverted" data-track={track}>
      <div className="section-content">
        <div className="txt-wrapper">
          {mobile ?
            <SubTitle>
              双主摄， 入镜稳准狠<br/>一秒Action
            </SubTitle>
            :
            <SubTitle>
              双主摄
              <br />
              入镜稳准狠，一秒Action
            </SubTitle>
          }

          {/*<Description>*/}
          {/*  双主摄影像系统加持：5000万像素超大底传感器GN1；*/}
          {/*  <br/>*/}
          {/*  4800万像素超广角云台114°大视野，无需矫正，给你3倍视场范*/}
          {/*  <br/>*/}
          {/*  围的大片<sup>1</sup>。又稳又清晰，随时开拍。*/}
          {/*</Description>*/}
        </div>
        <LazyLoad>
          <Image className="img-wrapper" src={mobile ? CAMERA_LENS_M_2 : CAMERA_LENS_2} />
        </LazyLoad>
      </div>
    </div>
  );
}
